import ApplyLayout from 'components/ApplyLayout'
import ApplyOpenCallChoice from 'components/ApplyOpenCall/ApplyOpenCallChoice'
import getGlobalSettings from '../../helpers/getGlobalSettings'
import getSites from '../../helpers/getSites'
import StateInitializer from '../../components/StateInitializer'

function OpenCallChoice({globalSettings, sites}) {
  return (
    <StateInitializer globalSettings={globalSettings} sites={sites}>
      <ApplyLayout activeArea='open-call'>
        <ApplyOpenCallChoice />
      </ApplyLayout>
    </StateInitializer>

  )
}

export default OpenCallChoice

export async function getStaticProps({ params }) {
  const [globalSettings, sites] = await Promise.all([
    getGlobalSettings(),
    getSites(),
  ])
  return {
    props: {
      globalSettings,
      sites,
    },
  }
}
